import { createStyles } from '@mantine/emotion'

import { mediaHelper, rem } from '@affstore-ds/uikit'

export const useLanguageDropdownStyles = createStyles(() => ({
  targetElement: {
    '&&': {
      padding: rem(4),
      [`${mediaHelper.greaterThen('lg', true)}`]: {
        padding: rem(8),
      },
    },
  },
  targetElementSection: {
    '&[data-position=left]': {
      marginRight: rem(0),
    },
    '&[data-position=right]': {
      marginLeft: rem(0),
    },
  },
  targetElementLabel: {
    marginInline: rem(4),
    [`${mediaHelper.greaterThen('lg', true)}`]: {
      marginInline: rem(8),
    },
  },
}))
